<template>
  <div>
    <div>
      <p class="text-center" v-if="!this.chart.length">
        This user has not added any treatment.
      </p>
      <AddTreatmentModal ref="addTreatmentModal" @refresh="getUserCircle" />
      <div v-if="medicines.length" class="card-shadow card">
        <div class="chart-container" v-if="medicines.length">
          <!-- <HorizontalChart
            :treatment="medicines"
            :timespan="timeline"
            :shortest="shortest"
          /> -->
        </div>
        <div class="circle ">
          <div class="title">Effectiveness</div>
          <div class="d-flex flex-wrap">
            <div v-for="(effect, i) in effectiveness" v-bind:key="i">
              <div
                v-if="effect.effectiveness"
                class="description"
                :style="{
                  background: effect.color,
                  color: '#ffffff !important'
                }"
              >
                {{ effect.effectiveness }}
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="circle">
          <div class="title">Side Effects</div>
          <div class="d-flex flex-column">
            <div class=" mt-2" v-for="(side, i) in sideEffect" v-bind:key="i">
              <div v-if="side.sideEffect" class="d-flex flex-wrap">
                <div
                  class=" d-flex display-symptom"
                  v-for="(sideEff, i) in side.sideEffect"
                  :style="{ width: 'fit-content', margin: '6px' }"
                  :key="i"
                >
                  <span>{{ sideEff.display_name }}</span>
                  <span
                    :style="{
                      color: getEffectivenessColor(sideEff.effectiveness),
                      background: `${getEffectivenessColor(
                        sideEff.effectiveness
                      )}25`,
                      padding: '2px 5px',
                      'margin-left': '10px',
                      'border-radius': '5px'
                    }"
                    >{{ sideEff.effectiveness }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div>
      <div class="dovemed-card mt-4">
        <div class="title d-inline-block pb-3 text-uppercase">
          Side Effects
        </div>
        <p v-if="sideEffect.length === 0" class="text-center">
          <b>You have not added any side-effects for your condition.</b>
        </p>

        <div class="d-flex flex-column">
          <div
            class="display-symptom mt-2"
            v-for="(item, i) in medicationSideEffect"
            v-bind:key="i"
          >
            <div class="d-flex ">
              <div class="d-flex flex-column align-items-start">
                <b class="text-capitalize">
                  Medication : {{ item.medication[0].display_name }}
                </b>

                <div
                  :style="{
                    display: 'flex',
                    'flex-wrap': 'wrap',
                    'margin-top': '10px'
                  }"
                >
                  <div class="d-flex align-items-center ">
                    Side Effects :
                  </div>
                  <div
                    :style="{
                      display: 'flex',
                      'flex-wrap': 'wrap'
                    }"
                    v-if="item.sideEffect.length > 0"
                  >
                    <div
                      v-for="(sideEff, index) in item.sideEffect"
                      :key="index"
                    >
                      <div
                        v-if="sideEff.display_name"
                        :style="{
                          color: getEffectivenessColor(sideEff.effectiveness),
                          background: `${getEffectivenessColor(
                            sideEff.effectiveness
                          )}25`,
                          padding: '2px 5px',
                          'min-width': '100px',
                          'border-radius': '5px',
                          width: 'fit-content',
                          'font-size': '14px',
                          display: 'flex',
                          'justify-content': 'center',
                          margin: '10px'
                        }"
                      >
                        <div class="pr-3" :style="{ color: '#333333' }">
                          {{ sideEff.display_name || "N/A" }}
                        </div>
                        <div class="font-weight-bold">
                          {{ getEffectiveness(sideEff.effectiveness) }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>None</div>
                </div>
              </div>
              <!-- <div
                class=" d-flex display-symptom"
                :style="{ width: 'fit-content', margin: '6px' }"
                v-for="(sideEff, i) in side.sideEffect"
                :key="i"
              >
                <span>{{ sideEff.display_name }}</span>
                <span
                  :style="{
                    color: getEffectivenessColor(sideEff.effectiveness),
                    background: `${getEffectivenessColor(
                      sideEff.effectiveness
                    )}25`,
                    padding: '2px 5px',
                    'margin-left': '10px',
                    'border-radius': '5px',
                    'text-align': 'center',
                    height: 'fit-content'
                  }"
                  >{{ getEffectiveness(sideEff.effectiveness) }}</span
                >
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="dovemed-card mt-4">
        <div class="title d-inline-block pb-3 text-uppercase">
          Symptoms Related to {{ currentCircle.condition_type }}
        </div>
        <p v-if="symptoms.length === 0" class="text-center">
          <b>This user has not added any symptoms.</b>
        </p>
        <div v-for="symptom in symptoms" :key="symptom.id">
          {{ symptom.display_name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import HorizontalChart from "../HorizontalChart";
import AddTreatmentModal from "../../../Modals/AddTreatment";
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory";

const UserRepository = RepositoryFactory.get("user");

export default {
  name: "PatientTreatments",
  components: {
    // HorizontalChart,
    AddTreatmentModal
  },
  mounted() {
    this.getUserCircle();
    this.fetchData();
  },
  updated() {},
  data() {
    return {
      symptoms: [],
      activeId: 0,
      circleData: [],
      chart: [],
      medicines: [],
      timeline: [],
      sideEffect: [],
      color: [],
      effectiveness: [],
      medicationSideEffect: [],
      shortest: new Date().toString()
    };
  },
  watch: {
    chart: function() {
      const startArray = [];
      let length = 0;
      this.chart.map(async item => {
        startArray.push(item.startDates);
        length =
          item.chartData.length > length ? item.chartData.length : length;
      });
      if (startArray.length === this.chart.length) {
        const shortest = startArray.sort()[0];
        this.shortest = shortest;
        console.log(this.shortest);
        for (let i = 0; i <= length; i++) {
          this.timeline.push({
            data: this.chart.map(item => {
              const latest =
                item.chartData[i] && item.chartData[i] !== null
                  ? item.chartData[i]
                  : this.moment(new Date()).format("YYYY-MM-DD");
              const prev =
                i === 0
                  ? shortest
                  : item.chartData[i - 1] && item.chartData[i - 1] !== null
                  ? item.chartData[i - 1]
                  : this.moment(new Date()).format("YYYY-MM-DD");
              return this.moment(latest).diff(this.moment(prev), "days", true);
            }),
            backgroundColor: i % 2 !== 0 ? this.color : "#ededed"
          });
        }
      }
      console.log(this.shortest, this.timeline, "short");
    }
  },
  methods: {
    activate(index, circle) {
      const items = document.getElementsByClassName("sub-item");
      for (let i = 0; i < items.length; i++) {
        items[i].classList.remove("active");
      }
      items[index].classList.add("active");
      this.activeId = index;
      this.getUserTreatmentTable();
    },
    getUserCircle() {
      // UserRepository.getUserCircle(this.$route.params.id)
      //   .then(res => {
      //     this.circleData = res.data.data
      //     this.getUserTreatmentTable()
      //   })
      this.circleData = this.currentCircle;
      this.getUserTreatmentTable();
    },
    async fetchData() {
      const data = await UserRepository.getAbout(
        this.viewUser,
        this.currentCircle.id
      );
      this.symptoms = data.data.data ? data.data.data[0].symptoms : [];
    },
    getEffectiveness(effectiveness) {
      switch (effectiveness) {
        case "0":
          return "Mild";
        case "50":
          return "Moderate";

        case "100":
          return "Severe";
        default:
          break;
      }
    },

    getEffectivenessColor(effectiveness) {
      switch (effectiveness) {
        case "0":
          return "#14DE0D";
        case "50":
          return "#F6B156";

        case "100":
          return "#FF4400";
        default:
          break;
      }
    },
    getUserTreatmentTable() {
      UserRepository.getTreatments(this.viewUser, this.currentCircle.id).then(
        res => {
          console.log(res.data, "chart data");

          this.chart = res.data
            ? res.data.data.map((item, ind) => {
                item.key = ind + item.dob;
                this.effectiveness.push({
                  color:
                    item.effectiveness === "0"
                      ? "#FF0000"
                      : item.effectiveness === "50"
                      ? "#FFA500"
                      : "#008000",
                  effectiveness: item.effectiveness
                });
                this.color.push(
                  item.effectiveness === "0"
                    ? "#FF0000"
                    : item.effectiveness === "50"
                    ? "#FFA500"
                    : "#008000"
                );
                if (item.side_effect) {
                  this.sideEffect.push({
                    color:
                      item.effectiveness === "0"
                        ? "#FF0000"
                        : item.effectiveness === "50"
                        ? "#FFA500"
                        : "#008000",
                    sideEffect: [...item.side_effect]
                  });
                }
                if (item.treatment_type === "Medication") {
                  this.medicationSideEffect.push({
                    sideEffect: [...item.side_effect],
                    medication: [...item.treatment]
                  });
                }
                let med = item.treatment[0].display_name.toLowerCase();
                const words = med.split(" ");

                med = words
                  .map(word => {
                    let up = word[0].toUpperCase() + word.slice(1);
                    return up;
                  })
                  .join(" ");

                this.medicines.push(med);
                this.medicationSideEffect.map(ele => {
                  ele.medication[0].display_name = ele.medication[0].display_name.toLowerCase();
                  return ele;
                });
                console.log(this.medicationSideEffect);
                const b = [];
                item.treatment_duration
                  .sort((a, b) => this.moment(a[0]).diff(this.moment(b[0])))
                  .sort((a, b) => this.moment(a[1]).diff(this.moment(b[1])))
                  .map(item => b.push(...item));
                let c = [];
                c.push(b[0]);
                let greater = b[1];
                let i = 2;
                let diff = 2;
                while (i < b.length - 1) {
                  if (b[i] < greater) {
                    greater = b[i + 1];
                    diff = 2;
                  } else if (b[i] > greater) {
                    c.push(greater);
                    c.push(b[i]);
                    greater = b[i + 1];
                    diff = 2;
                  } else {
                    greater = b[i + 1];
                  }
                  i += diff;
                }
                c.push(greater);
                item.chartData = c;
                item.startDates = item.chartData[0];
                return item;
              })
            : [];
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.display-symptom {
  justify-content: space-between;
  padding: 16px 24px;
  background: rgba(37, 103, 237, 0.05);
  border-radius: 5px;
}
.secondary-nav {
  padding: 0 10px;
  background: #f3f3f3;
  margin-bottom: 20px;

  .sub-navigation {
    padding: 5px 0;
    display: flex;

    .sub-nav {
      padding: 0;
      list-style: none;
      margin-bottom: 5px;

      li.sub-item {
        display: inline-block;
        margin: 10px 40px 0 0;
        cursor: pointer;

        &.active {
          color: #4d4e56;
          text-decoration: none !important;
          font-weight: bold;
          border-bottom: 2px solid #4072ee;
        }
      }
    }
  }
}
.card {
  padding: 40px 20px;
  width: 100%;
  .chart-container {
    width: 100%;
    height: 400px !important;
  }
  .circle {
    display: flex;
    margin-top: 20px;
    align-items: center;
    .title {
      height: 19px;
      color: #999999;
      font-size: 16px;
      margin-right: 20px;
      font-weight: bold;
    }
    .description {
      color: #343434;
      font-size: 16px;
      padding: 0.25em 1em;
      border-radius: 0.5em;
      margin: 0.5em;
    }
    .side {
      margin-right: 40px;
      text-align: center;
      padding: 0 20px;
      border-radius: 20%;
      background: #4072ee;
      color: #f3f3f3;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Patient/view/ViewPatientTreatments.vue